import { useQuery } from "@tanstack/react-query";

import { BASE_QUERY_KEY } from "../../utils/constants";
import useUpdateListQuery from "../../utils/use-update-list-query";

import useAccessRequestsApi from "./use-access-requests-api";
import { QUERY_KEY as LIST_ACCESS_REQUESTS_QUERY_KEY } from "./use-list-access-requests";

export const QUERY_KEY = "getAccessRequest";

export default function useGetAccessRequest(id: string, refetch?: number) {
  const api = useAccessRequestsApi();
  const updateListQuery = useUpdateListQuery([
    BASE_QUERY_KEY,
    LIST_ACCESS_REQUESTS_QUERY_KEY,
  ]);

  const fetch = async () => {
    const request = await api.getAccessRequest({ id });
    updateListQuery(request);
    return request;
  };

  return useQuery([BASE_QUERY_KEY, QUERY_KEY, id], fetch, {
    refetchInterval: refetch,
  });
}
